<rappider-custom-endpoint-list [endpointsGridConfig]="MODEL_ENDPOINT_LIST_CONFIG_FOR_PROJECT_DESIGN"
                               [animateTable]="animateTable"
                               [stopScrollingToView]="stopScrollingToView"
                               [enableRowPointer]="enableRowPointer"
                               [showNextModel]="showNextModel"
                               (rowActionClick)="onEndpointRowActionClick($event)"
                               (endpointDisplayed)="onEndpointDisplayed($event)"></rappider-custom-endpoint-list>
